import { CommonHelper } from 'src/utils/commonHelper';

const registeredOrigin = String(process.env.REACT_APP_REDIRECT_URL || '').replace(/\/$/, '');

export default function MetaOAuthBridgeIframe() {
  if (!CommonHelper.CustomDomain() || !registeredOrigin) return null;

  return (
    <>
      <iframe
        id="facebook-oauth-bridge-iframe"
        src={`${registeredOrigin}/facebook-redirect`}
        style={{ display: 'none' }}
        title="Facebook OAuth bridge"
      />
      <iframe
        id="instagram-oauth-bridge-iframe"
        src={`${registeredOrigin}/instagram-redirect`}
        style={{ display: 'none' }}
        title="Instagram OAuth bridge"
      />
    </>
  );
}
